export const createLastLogin = (): void => {
	const loginTime = Date.now();
	localStorage.setItem('lastLogin', loginTime.toString());
};

export const removeLastLogin = (): void => {
	localStorage.removeItem('lastLogin');
};

export const getLastLogin = (): number => {
	const lastLogin = localStorage.getItem('lastLogin');
	return lastLogin ? parseInt(lastLogin) : 0;
};
